import { NavLink, Outlet } from 'react-router-dom'
import { useI18n } from '../../../utils/i18n'

const GROUPS = [
  { label: '经营', labelEn: 'Workspace', items: [['overview', '概览', 'Overview'], ['orders', '订单', 'Orders'], ['payments', '支付', 'Payments'], ['products', '商品', 'Products']] },
  { label: '履约', labelEn: 'Fulfillment', items: [['fulfillment', '履约', 'Fulfillment'], ['tracking', '物流追踪', 'Tracking'], ['exceptions', '异常', 'Exceptions']] },
  { label: '系统', labelEn: 'System', items: [['operations', '操作记录', 'Activity'], ['integrations', '前端接入', 'Integrations'], ['users', '成员与权限', 'Members'], ['settings/overview', '渠道总览', 'Channels'], ['settings/payments', '支付渠道', 'Payment providers'], ['settings/logistics', '物流渠道', 'Logistics providers'], ['notifications', '通知', 'Notifications'], ['updates', '更新记录', 'Updates']] },
]

export default function CommerceLayout() {
  const { lang } = useI18n()
  const zh = lang === 'zh'
  return (
    <section className="chamii-commerce-workspace space-y-5">
      <header className="border-b border-slate-200 pb-4 dark:border-slate-800">
        <h1 className="text-2xl font-extrabold text-brand-textDark dark:text-white">Commerce</h1>
        <p className="mt-1 text-sm text-brand-text dark:text-slate-400">{zh ? 'Chamii 订单、支付、商品与履约管理' : 'Chamii orders, payments, products and fulfillment'}</p>
      </header>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[190px_minmax(0,1fr)]">
        <nav aria-label={zh ? 'Commerce 管理' : 'Commerce management'} className="flex gap-4 overflow-x-auto lg:block lg:space-y-5 lg:overflow-visible">
          {GROUPS.map((group) => <div className="shrink-0 space-y-1" key={group.label}>
            <h2 className="px-3 pb-1 text-[11px] font-bold uppercase tracking-wider text-slate-400">{zh ? group.label : group.labelEn}</h2>
            {group.items.map(([path, label, labelEn]) => <NavLink key={path} to={path} className={({ isActive }) => `block rounded-sm px-3 py-2 text-sm font-semibold transition-colors ${isActive ? 'bg-violet-100 text-violet-900 dark:bg-violet-950/60 dark:text-violet-100' : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-900'}`}>{zh ? label : labelEn}</NavLink>)}
          </div>)}
        </nav>
        <div className="min-w-0"><Outlet /></div>
      </div>
    </section>
  )
}
